var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showPreloader } from "../../components/preloader";
import SearchResultKeys from "../../components/search_result_keys";
import useSimilarApi from "./api/similarApi";
import { addLiveEventListener, startIconLoading, stopIconLoading } from "../../utils";
import $ from '../../vendor/dom7';
import { StatusClassNames } from "../../types/StatusClassNames";
import EventBus from "../../events/EventBus";
var timerId;
var searchRequest;
export default function initSimilarProducts() {
    var element = document.getElementById('similar-products');
    var searchInput = document.getElementById('similar-search');
    var searchResults = document.getElementById('similar-search-result');
    if (!element || !searchInput || !searchResults) {
        return;
    }
    var productId = parseInt(element.dataset.productId);
    var api = useSimilarApi(productId);
    new SearchResultKeys(searchInput, searchResults, '.search-result__item', onSelect);
    addLiveEventListener(element, 'click', ['.similar-vote--up', '.similar-vote--down'], function () {
        return __awaiter(this, void 0, void 0, function () {
            var wrap, vote, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        wrap = $(this).parents('.prod-teaser');
                        vote = this.matches('.similar-vote--up') ? 'upvote' : 'downvote';
                        startIconLoading(this);
                        return [4 /*yield*/, api.vote(vote, parseInt(wrap.data('id')))];
                    case 1:
                        data = _a.sent();
                        if (data.upvotes !== undefined) {
                            wrap.find('.prod-teas__vote-item--up .stats-item__label').text(data.upvotes.toString());
                        }
                        if (data.downvotes !== undefined) {
                            wrap.find('.prod-teas__vote-item--down .stats-item__label').text(data.downvotes.toString());
                        }
                        wrap.find('.is-pressed').removeClass(StatusClassNames.pressed);
                        if (data.active) {
                            wrap.find(data.active === 'upvote' ? '.similar-vote--up' : '.similar-vote--down').addClass(StatusClassNames.pressed);
                        }
                        stopIconLoading(this);
                        return [2 /*return*/];
                }
            });
        });
    });
    addLiveEventListener(element, 'click', '.similar-vote--delete', function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        showPreloader();
                        return [4 /*yield*/, api.delete(parseInt($(this).parents('.prod-teaser').data('id')))];
                    case 1:
                        _a.sent();
                        document.location.reload();
                        return [2 /*return*/];
                }
            });
        });
    });
    // search
    searchInput.addEventListener('input', function () {
        var txt = searchInput.value.trim();
        var lastQuery = searchInput.dataset.lastQuery;
        clearTimeout(timerId);
        if (searchRequest) {
            searchRequest.abort();
        }
        if (txt.length < 2) {
            searchInput.dataset.lastQuery = '';
        }
        else {
            if (txt === lastQuery) {
                return;
            }
            timerId = setTimeout(function () {
                return __awaiter(this, void 0, void 0, function () {
                    var data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                searchInput.dataset.lastQuery = txt;
                                return [4 /*yield*/, api.search(txt)];
                            case 1:
                                data = _a.sent();
                                searchResults.innerHTML = data.html;
                                EventBus.emit('products:load');
                                searchRequest = null;
                                searchResults.show();
                                searchInput.focus();
                                return [2 /*return*/];
                        }
                    });
                });
            }, 400);
        }
    });
    searchInput.addEventListener('blur', function () { return setTimeout(function () { return searchInput.matches(':not(:focus)') && searchResults.close(); }, 200); });
    searchInput.addEventListener('focus', function () {
        if (searchInput.value.trim().length >= 2) {
            searchResults.show();
            searchInput.focus();
        }
    });
    addLiveEventListener(searchResults, 'click', 'a', function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                onSelect(this);
                return [2 /*return*/];
            });
        });
    });
    function onSelect(el) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        el = el === null || el === void 0 ? void 0 : el.closest('.search-result__item');
                        if (!el) {
                            return [2 /*return*/];
                        }
                        showPreloader();
                        return [4 /*yield*/, api.add(parseInt(el.dataset.id))];
                    case 1:
                        _a.sent();
                        document.location.reload();
                        return [2 /*return*/];
                }
            });
        });
    }
    if (element.querySelector('.prod-teaser')) {
        setTimeout(function () {
            return __awaiter(this, void 0, void 0, function () {
                var data, index, el;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, api.getActive()];
                        case 1:
                            data = _a.sent();
                            for (index in data.active) {
                                el = element.querySelector("[data-id=\"".concat(index, "\"] .similar-vote--").concat(data.active[index] === 'upvote' ? 'up' : 'down'));
                                if (el) {
                                    el.classList.add(StatusClassNames.pressed);
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }, 1000);
    }
}
